import type * as lazyIndex from "./lazyIndex";
import { logStartGreyError } from "owa-analytics-start";
import { LazyAction, LazyBootModule } from "owa-bundling-light";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

export const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule(() => import(/* webpackChunkName: "PlacesSignout" */ "./lazyIndex"), { name: "PlacesSignout" });

export const lazyCleanUpPlacesLocalStorage: LazyAction<typeof lazyIndex.cleanUpPlacesLocalStorage, typeof lazyModule> = new LazyAction(lazyModule, m => m.cleanUpPlacesLocalStorage);

export const lazyCleanUpPlacesSessionStorage: LazyAction<typeof lazyIndex.cleanUpPlacesSessionStorage, typeof lazyModule> = new LazyAction(lazyModule, m => m.cleanUpPlacesSessionStorage);

export const lazyCleanUpPlacesIndexedDB: LazyAction<typeof lazyIndex.cleanUpPlacesIndexedDB, typeof lazyModule> = new LazyAction(lazyModule, m => m.cleanUpPlacesIndexedDB);

export const lazyCleanUpPlacesOfflineSync: LazyAction<typeof lazyIndex.cleanUpPlacesOfflineSync, typeof lazyModule> = new LazyAction(lazyModule, m => m.cleanUpPlacesOfflineSync);

// Preload the module to expect that it is loaded when needed
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function catch called at module scope is not allowed. This may cause unwanted side effects.
 *	> Function importModule called at module scope is not allowed. This may cause unwanted side effects. */
lazyModule.importModule("PlacesSignoutPreload")?.catch(err => {
    logStartGreyError("PlacesSignoutPreloadError", getModuleContextMailboxInfo(), err);
});
